/**
 * Best-effort label from provider URL (optional explicit title wins).
 * @param {string} url
 * @param {string} lang  'mm' | other
 */
export function deriveIframeGameTitle(url, lang = 'en') {
  if (url == null || typeof url !== 'string') return '';
  const u = url.toLowerCase();
  const pick = (en, mm) => (lang === 'mm' ? mm : en);

  if (u.includes('yoeyar-skm') || u.includes('skm.vercel')) return pick('Shan Koe Mee', 'ရှမ်းကိုးမီး');
  if (u.includes('bugyee') || u.includes('bugyee_game')) return pick('Bu Gyee', 'ဘူကြီး');
  if (u.includes('forest')) return pick('Forest Party', 'Forest Party');
  if (u.includes('galone')) return pick('Galone Galone', 'Galone Galone');
  if (u.includes('buffalo') || u.includes('african')) return pick('African Buffalo', 'ကျွဲဂိမ်း');
  if (u.includes('/live') || u.includes('live-casino') || u.includes('livecasino') || u.includes('evolution') || u.includes('/evo') || u.includes('og.')) return pick('Live Casino', 'လိုင်း ကာစီနို');
  if (u.includes('fish') || u.includes('fishing')) return pick('Fishing', 'ငါးဖမ်း');
  if (u.includes('arcade') || u.includes('pgsoft') || u.includes('pg-')) return pick('Arcade', 'အာကိတ်');
  if (u.includes('pragmatic') || u.includes('slot') || u.includes('jili') || u.includes('pp875')) return pick('Slot', 'စလော့');
  if (u.includes('vercel.app')) return pick('Game', 'ဂိမ်း');
  if (u.trim().startsWith('<')) return pick('Game', 'ဂိမ်း');
  return pick('Game', 'ဂိမ်း');
}

/**
 * Open a returned game URL inside the app iframe route (/iframeURL).
 * Works for http(s) URLs (iframe src) and HTML fragments (iframe srcdoc).
 *
 * @param {import('vue-router').default} router
 * @param {import('vuex').Store} store
 * @param {string|null|undefined} url
 * @param {string} [explicitTitle] optional display name (skips URL heuristics)
 */
export function openGameInIframe(router, store, url, explicitTitle) {
  if (url == null || url === '') return;
  const lang = store.state.language || 'en';
  const title = explicitTitle || deriveIframeGameTitle(url, lang);
  store.commit('setIframeURL', url);
  store.commit('setIframeGameTitle', title);
  router.push('/iframeURL').catch(() => {});
}
